import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';
import './AdminLogin.css';

const LOCAL_API_BASE_URL = "http://localhost:5000";
const RENDER_API_BASE_URL = "https://wecareehs-backend.onrender.com";
const API_BASE_URL = process.env.REACT_APP_USE_RENDER === "true" ? RENDER_API_BASE_URL : LOCAL_API_BASE_URL;

const AdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { adminLogin } = useContext(AuthContext);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Login failed');
      }

      adminLogin(data.token, data.user);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="split-login-container">
      {/* Left Visual Panel - Admin Variant */}
      <div className="visual-panel admin-visual">
        <div className="visual-content">
          <h1 className="visual-heading">Command<br />Center.</h1>
          <p className="visual-subtext">Restricted Access. Authorized Personnel Only.</p>
        </div>
        <div className="abstract-shape admin-shape"></div>
        <div className="abstract-shape-2 admin-shape-2"></div>
      </div>

      {/* Right Form Panel */}
      <div className="form-panel">
        <div className="form-content">
          <div className="brand-logo-area">
            <div className="logo-dot admin-dot"></div>
          </div>

          <div className="login-header">
            <h2>Admin Portal</h2>
            <p>Please verify your identity to proceed.</p>
          </div>

          <form onSubmit={handleSubmit} className="split-form">
            <div className="minimal-input-group">
              <label>Admin Email</label>
              <input
                type="email"
                name="email"
                className="minimal-input"
                value={formData.email}
                onChange={handleChange}
                placeholder="admin@wecare.com"
                required
              />
            </div>

            <div className="minimal-input-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                className="minimal-input"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
              />
            </div>

            {error && <div className="status-message error">{error}</div>}

            <button type="submit" className="action-btn admin-btn" disabled={loading}>
              {loading ? "Verifying..." : "Access Dashboard"} <FaArrowRight />
            </button>
          </form>

          <div className="panel-footer">
            <p>Not an admin? <a href="/login" className="highlight-link">Return to User Login</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
